const DEFAULT_MESSAGE_HEIGHT = 100;
const HEIGHT_TOLERANCE = 50;
const TIP_MENU_ITEM_HEIGHT = 40;
const LIVE_TOUCH_HEIGHT = 200;

/**
 * Get estimated rendered height for the message
 * (To properly compare the scroll position after it rendered at the bottom)
 */
export const getEstimatedMessageHeight = (message: any): number => {
  if (message?.isGif && message.gifUrls?.height) {
    return Number(message.gifUrls.height) + HEIGHT_TOLERANCE;
  } else if (message?.gameName === 'TipMenu') {
    const tipMenuLength = [...message.notificationExtra.matchAll('"pr"')].length;

    return ((tipMenuLength + 1) * TIP_MENU_ITEM_HEIGHT) + HEIGHT_TOLERANCE;
  } else if (message?.type === 'LIVE_TOUCH') {
    return LIVE_TOUCH_HEIGHT;
  } else if (message?.translatedMessage) {
    return DEFAULT_MESSAGE_HEIGHT * 2;
  }

  return DEFAULT_MESSAGE_HEIGHT;
};
